const form = document.getElementById("loginForm");
const msg = document.getElementById("msg");
const blocker = document.getElementById("page-blocker");
const banner = document.getElementById("cookie-banner");
const mainContent = document.querySelector("main");

form.addEventListener("submit", async (e) => {
  e.preventDefault();

  const email = form.email.value.trim();
  const password = form.password.value;

  msg.textContent = "";

  try {
    const res = await fetch("/api/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
      credentials: "include", // <- zwingend für Session-Cookie
    });

    const data = await res.json();

    if (res.ok && data.success) {
      // Verwende die Redirect-URL vom Server
      window.location.href = data.redirect;
    } else {
      msg.textContent = "❌ " + (data.error || "Login fehlgeschlagen");
    }
  } catch (err) {
    console.error(err);
    msg.textContent = "Verbindungsfehler.";
  }
});
